"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMonitorDeEntregas = exports.yupMonitorDeEntregas = exports.schemaGradeProfessor = exports.yupGradeProfessor = void 0;
const yup = __importStar(require("yup"));
// import { IGrade } from './grade';
exports.yupGradeProfessor = yup.object({
    idCurso: yup.number().positive().integer().label('Curso'),
    idSerie: yup.number().positive().integer().label('Série'),
    idTurma: yup.number().positive().integer().label('Turma'),
    idMateria: yup.number().positive().integer().label('Matéria'),
    idProfessor: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Professor'),
    // aulas: yup.number().positive().integer().label('Aulas'),
    // segunda: yup.string().max(6).nullable().label('Segunda'),
    // terca: yup.string().max(6).nullable().label('Terca'),
    // quarta: yup.string().max(6).nullable().label('Quarta'),
    // quinta: yup.string().max(6).nullable().label('Quinta'),
    // sexta: yup.string().max(6).nullable().label('Sexta'),
    // sabado: yup.string().max(6).nullable().label('Sabado'),
    regente: yup.boolean().required().default(false).label('Professor Regente'),
    idProfessor1: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Professor'),
    idProfessor2: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Professor'),
    idProfessor3: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Professor'),
});
exports.schemaGradeProfessor = exports.yupGradeProfessor.shape({});
exports.yupMonitorDeEntregas = yup.object({
    anoLetivo: yup.string().required().default(new Date().getFullYear().toString()).label('Ano letivo'),
    idProfessor: yup.number().notRequired().default(undefined).label('Professor'),
    idCurso: yup.number().notRequired().default(undefined).label('Curso'),
    idSerie: yup.number().notRequired().default(undefined).label('Série'),
    idTurma: yup.number().notRequired().default(undefined).label('Turma'),
    etapa: yup.number().required().default(1).label('Etapa'),
    situacao: yup.mixed().oneOf(['', '1', '2']).default('').label('Situação'),
});
exports.schemaMonitorDeEntregas = exports.yupMonitorDeEntregas.shape({});
